import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { GaFormlyUtil } from '../ga-formly.util';
import { ExtraFieldType } from '../extra-field-type';

@Component({
  selector: 'formly-field-combined-date',
  template: `
    <combined-date [value]="model[key]" [ngClass]="classNames" (valueChange)="onDateChange($event)"></combined-date>
    <input type="hidden" class="d-none" [formControl]="formControl" [formlyAttributes]="field">
  `
})
export class FormlyFieldCombinedDateComponent extends ExtraFieldType implements OnInit {
  constructor(
    private formlyUtil: GaFormlyUtil,
    private changeDetectorRef:ChangeDetectorRef
  ) {
    super();
  }

  public ngOnInit(): void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.COMBINED_DATE, <string>this.key, this.to.label);

    // register listener
    this.listen();
  }

  public onDateChange(value:Date):void {
    this.formControl.setValue(value);
    this.changeDetectorRef.detectChanges();
  }
}